import { render } from "./emoji_reactions.vue?vue&type=template&id=1d7d1862"
import script from "./emoji_reactions.js?vue&type=script&lang=js&external"
export * from "./emoji_reactions.js?vue&type=script&lang=js&external"

import "./emoji_reactions.vue?vue&type=style&index=0&id=1d7d1862&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__